import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router';

const ListPage = lazy(() => import('./pages/returns-list-page').then((m) => ({ default: m.ReturnsListPage })));
const DetailPage = lazy(() => import('./pages/return-detail-page').then((m) => ({ default: m.ReturnDetailPage })));
const ReportPage = lazy(() => import('./pages/returns-report-page').then((m) => ({ default: m.ReturnsReportPage })));

const Fallback = () => (
  <div role="status" aria-label="Carregando" className="flex flex-col gap-3">
    {Array.from({ length: 4 }, (_, i) => (
      <div key={i} aria-hidden className="skeleton h-10 w-full" />
    ))}
  </div>
);

/** Montado em `devolucoes/*`. */
export function ReturnsRoutes() {
  return (
    <Suspense fallback={<Fallback />}>
      <Routes>
        <Route index element={<ListPage />} />
        <Route path="relatorios" element={<ReportPage />} />
        <Route path=":id" element={<DetailPage />} />
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </Suspense>
  );
}
